import React, { useEffect } from 'react';

import { ProductById } from 'src/shared/types/product';

import { addToast } from 'src/shared/components/ui';
import {
  ButtonV2,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader
} from 'src/shared/components/ui';

import { useProductDetailForm } from '../hooks/useProductDetailForm';
import { useUpdateProduct } from '../hooks/useUpdateProduct';

interface ProductDetailFormModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  product: ProductById;
}
const ProductDetailFormModal: React.FC<ProductDetailFormModalProps> = ({
  isOpen,
  onOpenChange,
  product
}) => {
  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors }
  } = useProductDetailForm({ name: product?.detail?.name });

  const productMutation = useUpdateProduct();

  useEffect(() => {
    if (product) {
      reset({
        name: product?.detail?.name || ''
      });
    }
  }, [product, reset]);

  const onSubmit = (data: any) => {
    productMutation.mutate(
      { ...data, id: product?.id },
      {
        onError: (error) => {
          const { name } = JSON.parse(error.message);

          setError('name', { message: name });
        },
        onSuccess: () => {
          onOpenChange(false);
          addToast({
            color: 'success',
            title: 'Product updated successfully.'
          });
        }
      }
    );
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 p-5 border-b border-gray-4">
              Edit product
            </ModalHeader>
            <ModalBody className="p-5 flex flex-col gap-5">
              <form id="organization-form" onSubmit={handleSubmit(onSubmit)}>
                <Input
                  label="Name"
                  errorMessage={errors.name?.message}
                  isInvalid={!!errors.name}
                  {...register('name')}
                />
              </form>
            </ModalBody>
            <ModalFooter className="justify-start border-t border-gray-4 p-5">
              <ButtonV2
                size="sm"
                color="default"
                variant="flat"
                onPress={() => onClose()}
                isDisabled={productMutation.isPending}
              >
                Close
              </ButtonV2>
              <ButtonV2
                form="organization-form"
                type="submit"
                size="sm"
                color="dark"
                isDisabled={productMutation.isPending}
                isLoading={productMutation.isPending}
              >
                Save
              </ButtonV2>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ProductDetailFormModal;
